/********************************************************************
Alexander Self
10/25/17
Map modal: Users recieve reports based onthe fields the select
********************************************************************/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ContentHeader from './field/field_content_header';
//import FieldHoursList from './field/field_hours_list';
//import FieldTable from './field/field_custom_table';
import macOrchard from '../../img/macOrchard.jpg';
import rhs from '../../img/HIMN_logo.jpg';
const $ = window.$;

const MapModal = ({ field, selectedField, fieldHours, lastVisited, harvest, hours }) => {
  $(document).ready(() => {
    $(`#${field.id}`).modal({
      //startingTop: '60%'//, // Starting top style attribute
      endingTop: '20%'
    });
  });
  return (
    <div id={field.id} className="modal field-modal">
      <div className="modal-content">
        <div className="row">
          <div className="col s12 m12 l12 xl12">
            <ContentHeader field={field} selectedField={selectedField} logo={rhs} background={macOrchard} />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4 l4 xl4">
            <div className="card light-blue" id={'lastVisited'}>
              <div className="card-content white-text">
                <div className="row">
                  <div className="col s12 m12 l12 xl12">
                    <span className="flow-text left-align">Last Harvest Visit:</span>
                    <span className="flow-text right-align">
                      { lastVisited === undefined ? 'N/A' : Object.keys(lastVisited).length > 0 ?
                        <span>
                          { lastVisited.lastHarvestVisit.date === 'N/A' ? lastVisited.lastHarvestVisit.date :
                            moment(lastVisited.lastHarvestVisit.date).format('YYYY-MM-DD') }
                        </span>
                         : 'N/A'
                       }
                    </span>
                  </div>
                  <div className="col s12 m12 l12 xl12">
                    <span className="flow-text left-align">Last General Visit:</span>
                    <span className="flow-text right-align">
                      { lastVisited === undefined ? 'N/A' : Object.keys(lastVisited).length > 0 ?
                        <span>
                          { lastVisited.lastWorkVisit.date === 'N/A' ? lastVisited.lastWorkVisit.date :
                            moment(lastVisited.lastWorkVisit.date).format('YYYY-MM-DD') }
                        </span>
                         : 'N/A'
                       }
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/*<FieldHoursList field={fieldHours} />*/}
          </div>
          <div className="col s12 m8 l8 xl8">
            {/* <FieldTable fieldHoursByDate={fieldHoursByDate} /> */}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <a className="modal-action modal-close waves-effect waves-green btn-flat">Close</a>
      </div>
    </div>
  )
}
function mapStateToProps(state) {
  return {
    user: state.auth.user,
    location: state.misc.location,
    selectedField: state.misc.fieldInfo.basicInfo,
    fieldHours: state.misc.fieldInfo.hours,
    lastVisited: state.misc.fieldInfo.lastVisited,
    harvest: state.misc.fieldInfo.harvest,
    work: state.misc.fieldInfo.work
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MapModal);























/* END */



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard_map_modal.js